import React, { useEffect, useRef } from 'react';

export default function AdComponent({ position }) {
  const adRef = useRef(null);

  useEffect(() => {
    // Push ad only if we're in production
    if (process.env.NODE_ENV === 'production') {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error('AdSense error:', error);
      }
    }
  }, []);

  // Show development placeholders in non-production environments
  if (process.env.NODE_ENV !== 'production') {
    return (
      <div className={`ad-${position} text-center my-4 p-2 border-dashed border-2`}>
        <div>
          <small>Advertisement</small>
          <div className="ad-placeholder h-20 w-full bg-gray-100"></div>
        </div>
      </div>
    );
  }

  // Get the ad slot based on position
  const getAdSlot = () => {
    return position === 'header' 
      ? 'YOUR_HEADER_AD_UNIT_ID'  // Replace with your header ad unit ID
      : 'YOUR_FOOTER_AD_UNIT_ID'; // Replace with your footer ad unit ID
  };

  return (
    <div className={`ad-${position} text-center my-4`}>
      <small>Advertisement</small>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8117599711540172" // Replace with your publisher ID
        data-ad-slot={getAdSlot()}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}